"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.firstLetterToUppercase = void 0;
exports.formatPhone = formatPhone;
exports.formatPhoneWithSpecialChars = formatPhoneWithSpecialChars;
var _validation = require("./validation");
function formatPhone(phone) {
  if (!(0, _validation.isValidPhone)(phone)) {
    return phone;
  }
  const rawPhone = phone.replace(/\D+/g, '');
  return `+${rawPhone.replace(/(\d)(\d{3})(\d{3})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5')}`;
}
function formatPhoneWithSpecialChars(phone) {
  if (!(0, _validation.isValidPhone)(phone)) {
    return phone;
  }
  const rawPhone = phone.replace(/\D+/g, '').replace(/^8/, '7');
  return `+${rawPhone.replace(/(\d)(\d{3})(\d{3})(\d{2})(\d{2})/, `$1 ($2) $3-$4-$5`)}`;
}
const firstLetterToUppercase = str => {
  return str[0].toUpperCase() + str.slice(1);
};
exports.firstLetterToUppercase = firstLetterToUppercase;